import { PictureBox } from './PictureBox';
export default PictureBox;
